import { meetingQueryOptions } from '@/pages/private/VideoMeeting/hooks/meeting.hook';
import { queryClient } from '@/providers/QueryClientProvider';
import { MeetingService } from '@/services/meeting.service';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/meetings/$id/')({
  loader: async ({ params }) => {
    const meetingService = new MeetingService();

    await meetingService.refreshToken(params.id);

    const queryOptions = meetingQueryOptions({ id: params.id });

    return await queryClient.fetchQuery(queryOptions);
  },
});
